/**
 * The React Router adapter for the neutral route description (#1798).
 *
 * `@resource-kit/core` emits `{ path, kind, permission, view }` and knows
 * nothing about any router — that is what lets the kit be lifted out of this
 * app. Turning those records into `<Route>` elements is THIS project's job, and
 * this file is the whole of it: swapping to another router means rewriting this
 * one module, not the declarations.
 *
 * The elements are returned as an array rather than a component because React
 * Router requires `<Route>` to be a direct child of `<Routes>`; a component in
 * between would be silently ignored.
 */
import { Route } from 'react-router-dom';
import type { DerivedRoute } from '@resource-kit/core';
import { PermissionGuard } from '@components/auth/PermissionGuard';
import type { PermissionKey } from '@/permissions';
import type { ActionView } from './defineActions';

export function actionRoutes(
  routes: readonly DerivedRoute<PermissionKey, ActionView>[],
): React.ReactElement[] {
  return routes.map((route) => (
    <Route
      key={route.path}
      path={route.path}
      element={
        <PermissionGuard permission={route.permission}>{route.view.render()}</PermissionGuard>
      }
    />
  ));
}
